
import * as types from "../config/types";

const initialState = {
  loading: false,
  userList: [],
  error: null
};

export default function userManage (state = initialState, action)  {
  switch (action.type) {
    case types.GET_USER_LIST_REQUEST: {
      return {
        ...state,
        loading: true
      };
    }
    case types.GET_USER_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        userList: action.payload.userList.data
      };
    }
    case types.GET_USER_LIST_FAILED: {
      return {
        ...state,
        loading: false,
        error: "FAILED",    
      };
    }
    default:
      return state;
  }
};

